export default __webpack_public_path__ + "static/media/Page_12.36beb0b1.png";